import script from "./CompanyCardFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyCardFooter.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyCardFooter.vue?vue&type=style&index=0&id=20a8c308&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20a8c308"]])

export default __exports__